// eslint-disable-next-line import/prefer-default-export
export enum GroupUserRoles {
  Member = "member",
  Admin = "admin",
  Watcher = "watcher",
}
